import { render, staticRenderFns } from "./BookingProfile.vue?vue&type=template&id=3b3224ac&scoped=true&"
import script from "./BookingProfile.vue?vue&type=script&lang=js&"
export * from "./BookingProfile.vue?vue&type=script&lang=js&"
import style0 from "./BookingProfile.vue?vue&type=style&index=0&id=3b3224ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3224ac",
  null
  
)

export default component.exports